/** Highest first, as the mockup draws it. Zero is not a rating and gets no row. */
export const RATING_LADDER = [5, 4, 3, 2, 1] as const;

/** The scale residents answer on, before it is halved for display. */
export const RAW_SCORE_MAX = 10;

/** Replies the quote card reads before keeping the ones that carry words. */
export const QUOTE_SCAN_ROWS = 20;
